import styled from "styled-components"

import ModalSectionTitle from "components/common/ModalSectionTitle/ModalSectionTitle"

const SectionContent = styled.div`
  padding: 0 20px;
  margin-bottom: 20px;
`

const SubSectionTitle = styled.h4`
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  margin: 16px 0 8px;
`

const KeyIndicatorBlock = styled.div`
  &:first-child h4 {
    margin-top: 0;
  }
`

const BulletList = styled.ul`
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
`

const BulletItem = styled.li`
  font-size: 14px;
  color: #334155;
  line-height: 1.7;
  margin-bottom: 4px;
`

const SummaryText = styled.p`
  font-size: 14px;
  color: #334155;
  margin: 0 0 8px;
  line-height: 1.6;
`

const LoadingText = styled.p`
  font-size: 14px;
  color: #94a3b8;
  margin: 0;
  padding: 8px 0;
`

interface IndicatorBlock {
  title: string
  items: string[]
}

interface Props {
  isLoading: boolean
  blocks: IndicatorBlock[]
}

export const KeyIndicatorsSection = ({ isLoading, blocks }: Props) => (
  <>
    <ModalSectionTitle title="Key Indicators" />
    <SectionContent>
      {isLoading ? (
        <LoadingText>Loading...</LoadingText>
      ) : blocks.length > 0 ? (
        blocks.map((block, index) => (
          <KeyIndicatorBlock key={index}>
            <SubSectionTitle>{block.title}</SubSectionTitle>
            <BulletList>
              {block.items.map((item, itemIndex) => (
                <BulletItem key={itemIndex}>{item}</BulletItem>
              ))}
            </BulletList>
          </KeyIndicatorBlock>
        ))
      ) : (
        <SummaryText>No key indicators available.</SummaryText>
      )}
    </SectionContent>
  </>
)
